import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';
import { RaVersion } from '../rental-agreements.model';

import { RentalAgreementValueListModel } from './rental-agreement-values.model';

export interface RentalAgreementValuesService {
  getRentalAgreementValues(
    rentalAgreementUid: string,
    raVersion: RaVersion
  ): Observable<RentalAgreementValueListModel[]>;
}

@Injectable({
  providedIn: 'root'
})
export class ApiRentalAgreementValuesService extends BaseHttpService implements RentalAgreementValuesService {
  getRentalAgreementValues(
    rentalAgreementUid: string,
    raVersion: RaVersion = 'latest'
  ): Observable<RentalAgreementValueListModel[]> {
    return this.httpClient.get<RentalAgreementValueListModel[]>(`${this.baseApiUrl}/api/rentalAgreementValueItem`, {
      params:
        raVersion && raVersion != 'latest'
          ? { rentalAgreementUid, rentalAgreementVersion: raVersion.toString() }
          : { rentalAgreementUid }
    });
  }
}
